// eslint-disable-next-line max-classes-per-file
import { deserialize } from 'cerialize'
import { ShortDataModel } from 'Models'

export class PartnerMassUpdateModel {
	@deserialize public created_at: string
	@deserialize public email: string
	@deserialize public id: number
	@deserialize public incorporation_form: ShortDataModel
	@deserialize public is_active: boolean
	@deserialize public is_renewal: boolean
	@deserialize public manager: ShortDataModel
	@deserialize public name: string
	@deserialize public status: { name: string; slug: string; step: string }
	@deserialize public vat_number: string
	@deserialize public bin_number: string
}
